module.exports = __webpack_public_path__ + "9ca04ec7b33e3a1b08883379d1c62883.svg";